import { Injectable } from '@angular/core';
import { gql } from '@apollo/client/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CreateVisitHistoryInput } from '@libs/types/src/navigator/input-type/create-visit-history.input';
import { VisitHistoryGridItemObject } from '@libs/types/src/navigator/object-type/visit-history-grid.object';
import { EventObject } from '@libs/types/src/notifications/object-type/event.object';
import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';

@Injectable({ providedIn: 'root' })
export class NavigatorGqlService extends GqlServiceV2 {

    getVisitHistory() {
        return this.query<VisitHistoryGridItemObject[]>(
            `
                query {
                    visitHistory {
                        list {
                            url
                            data
                            created
                        }
                    }
                }
            `,
        );
    }

    createVisitHistory(input: CreateVisitHistoryInput) {
        return this.mutate<VisitHistoryGridItemObject>(
            `
                mutation($input: CreateVisitHistoryInput!) {
                    visitHistory {
                        create(input: $input) {
                            url
                        }
                    }
                }
            `,
            { input },
        );
    }

    visitHistorySubscription(userId: string): Observable<VisitHistoryGridItemObject> {
        return this.apollo.subscribe<{ visitHistory: VisitHistoryGridItemObject }>({
            query: gql`
                subscription($userId: String!) {
                    visitHistory(userId: $userId) {
                        url
                        data
                    }
                }
            `,
            variables: { userId },
        })
            .pipe(map((res) => res.data!.visitHistory));
    }

    eventSubscription(): Observable<EventObject> {
        return this.apollo.subscribe<EventObject>({
            query: gql`
                subscription {
                    events {
                        name
                    }
                }
            `,
        })
            .pipe(map((res) => res.data!));
    }

}
